import React, { useContext, useState, useEffect, useRef } from 'react';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Card, Button } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import { Context } from "../../context/Context";
import { CartContext } from '../../context/CartContext';
import CartForm from "../../components/toppo/forms/orders/cartForm";
import Iconify from '../../components/widgets/Iconify/Iconify';
import getElement from '../../config/axios';

const StyledRoot = styled('div')(({ theme }) => ({
    zIndex: 999,
    right: 0,
    display: 'flex',
    cursor: 'pointer',
    position: 'fixed',
    alignItems: 'center',
    top: theme.spacing(16),
    height: theme.spacing(5),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.25),
    color: theme.palette.text.primary,
    backgroundColor: '#3a3f56', // más claro que #262b3f
    animation: 'pulse 2s infinite',
    transition: 'transform 0.3s ease, opacity 0.3s ease',
    borderTopLeftRadius: Number(theme.shape.borderRadius) * 2,
    borderBottomLeftRadius: Number(theme.shape.borderRadius) * 2,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
}));


const StyledCartContent = styled(Card)(({ theme }) => ({
    position: 'fixed',
    top: 0,
    right: 0,
    width: '100%',
    maxWidth: '500px',
    height: '100%',
    backgroundColor: '#f8f9fa',
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
    padding: theme.spacing(3),
    overflowY: 'auto',
    borderTopLeftRadius: theme.spacing(2),
    borderBottomLeftRadius: theme.spacing(2),
}));

const CloseButton = styled(Button)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 1000,
    padding: theme.spacing(0.5),
    minWidth: 'auto',
}));

// ... [imports igual que antes]
const CartWidget = () => {
    const { cart, removeFromCart } = useContext(CartContext);
    const [openCart, setOpenCart] = useState(false);
    const cartRef = useRef(null);
    const navigate = useNavigate();
    const [auth] = useContext(Context);
    const [benefit, setBenefit] = useState({ check_benefit: false, value: 0 });
    const [appliedDiscount, setAppliedDiscount] = useState(0);

    console.log("auth:", auth);
    console.log("auth.user.id:", auth.user_id);

    const handleCartToggle = () => {
        setOpenCart(!openCart);
    };

    const handleClickOutside = (event) => {
        if (cartRef.current && !cartRef.current.contains(event.target)) {
            setOpenCart(false);
        }
    };

    useEffect(() => {
        if (openCart) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [openCart]);

    useEffect(() => {
  const fetchBenefit = async () => {
    try {
      console.log("Consultando beneficios para user_id:", auth.user_id);
      const res = await getElement(`/benefit/list/user/${auth.user_id}`);
      const benefits = res.data.rows;
      console.log("Beneficios obtenidos:", benefits);

      if (benefits.length > 0 && benefits[0].check_benefit) {
        setBenefit({
          check_benefit: true,
          value: benefits[0].value
        });
      } else {
        setBenefit({ check_benefit: false, value: 0 });
      }
    } catch (err) {
      console.error("Error al cargar el beneficio:", err);
    }
  };

  if (auth?.user_id) fetchBenefit();
}, [auth]);


    const getProductsWithAllSizes = () => {
        const grouped = {};

        cart.forEach(item => {
            const productId = item.productId;
            const color = item.variant?.option_1;
            const size = item.variant?.option_2;

            if (!productId || !color || !size) return;

            const key = `${productId}-${color}`;
            if (!grouped[key]) grouped[key] = new Set();
            grouped[key].add(size);
        });

        console.log("Grupos de tallas en carrito:", grouped);

        return Object.entries(grouped)
            .filter(([, sizes]) => ['S', 'M', 'L'].every(size => sizes.has(size)))
            .map(([key]) => key);
    };



    // Total sin descuento
    const totalOriginal = cart.reduce((total, item) => {
        return total + item.variant.price * item.quantity;
    }, 0);

    // Verificar si aplica descuento
    const eligibleKeys = getProductsWithAllSizes(); // Ej: ['20061-Verde Esmeralda']
    const appliesDiscount = benefit.check_benefit && eligibleKeys.length > 0;

    const discountAmount = appliesDiscount
        ? (totalOriginal * benefit.value) / 100
        : 0;



    const totalPrice = totalOriginal - discountAmount;

    const handleRemoveItem = (productId, variantId) => {
        removeFromCart(productId, variantId);
    };

    const handleCheckout = () => {
        console.log(JSON.stringify(cart, null, 2));
    };

    return (
        <StyledRoot onClick={() => !openCart && handleCartToggle()}>
            {!openCart && (
                <Badge showZero badgeContent={cart.length} color="error" max={99}>
                    <FontAwesomeIcon icon={faShoppingCart} width={24} height={24} onClick={handleCartToggle} style={{ color: 'white' }} />
                </Badge>
            )}

            {openCart && (
                <StyledCartContent ref={cartRef}>
                    <CloseButton variant="light" onClick={handleCartToggle}>
                        <Iconify icon="eva:close-fill" width={24} height={24} />
                    </CloseButton>
                    <Card border="light" className="bg-white shadow-sm mb-4">
                        <Card.Body>
                            <h5 className='mb-2'>Carrito</h5>
                            {cart.length === 0 ? (
                                <h5>El carrito está vacío.</h5>
                            ) : (
                                <>
                                    <Box sx={{ mb: 3 }}>
                                        <h6>Total de ítems: {cart.reduce((t, i) => t + i.quantity, 0)}</h6>
                                        <h6>Total sin descuento: ${totalOriginal.toFixed(2)}</h6>

                                        {appliesDiscount && (
                                            <>
                                                <h6 style={{ color: 'green' }}>
                                                    ✅ Descuento aplicado ({benefit.value}%): -${discountAmount.toFixed(2)}
                                                </h6>
                                                <h5>Total con descuento: ${totalPrice.toFixed(2)}</h5>
                                            </>
                                        )}

                                        {!appliesDiscount && benefit.check_benefit && (
                                            <h6 style={{ color: 'orange' }}>
                                                ⚠️ Para activar tu beneficio del {benefit.value}%, agrega todas las tallas de al menos un producto.
                                            </h6>
                                        )}
                                    </Box>

                                    {cart.map((item, index) => {
                                        const itemKey = `${item.productId}-${item.variant.option_1}`;
                                        const isEligible = eligibleKeys.includes(itemKey);

                                        const price = item.variant.price;
                                        const discountedPrice = isEligible
                                            ? price - (price * benefit.value) / 100
                                            : price;

                                        const itemTotal = discountedPrice * item.quantity;

                                        const itemName = item.variant.title === "Default Title"
                                            ? item.productName
                                            : item.variant.title;

                                        return (
                                            <Box key={index} sx={{ mb: 2 }}>
                                                <h6 className='mb-2' style={{ color: isEligible ? 'green' : '#4A5073' }}>
                                                    {itemName} - {item.quantity} unidades - ${itemTotal.toFixed(2)}
                                                    {isEligible && (
                                                        <small style={{ color: 'green', marginLeft: '8px' }}>
                                                            (-{benefit.value}%)
                                                        </small>
                                                    )}
                                                </h6>
                                                <Button variant="danger" onClick={() => handleRemoveItem(item.productId, item.variant.id)}>
                                                    Eliminar
                                                </Button>
                                            </Box>
                                        );
                                    })}

                                    <CartForm />
                                </>
                            )}
                        </Card.Body>
                    </Card>
                </StyledCartContent>
            )}
        </StyledRoot>
    );
};

export default CartWidget;
